import * as THREE from 'three'
import React, { useRef, useEffect, useState } from 'react'
import { useLoader, useFrame } from 'react-three-fiber';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader'
import { a, useSpring } from 'react-spring/three';

export default function DiscoBall({ leftTrigger, rightTrigger, flip, isPlaying, ...props }) {
  const mesh = useRef()
  const group = useRef()
  const gltf = useLoader(GLTFLoader, "/assets/discoBall.glb")

  const r = "/assets/envMap/";
  const urls = [r + "px.png", r + "nx.png",
  r + "py.png", r + "ny.png",
  r + "pz.png", r + "nz.png"];
  const [envMap] = useLoader(THREE.CubeTextureLoader, [urls])

  const matSettings = {
    drum: {
      roughness: 0.2,
      metalness: 1.0,
      envMap: envMap,
      envMapIntensity: 2,
      color: new THREE.Color("hsl(0, 0%, 25%)")
    }
  }

  useFrame(() => {
    if (!isPlaying) return
    const levels = AudioHandler.getVolume()
    mesh.current.rotation.y += 0.01;
    mesh.current.scale.set(levels * 2 + 2, levels * 2 + 2, levels * 2 + 2);
  })

  const [value, setValue] = useState(1);

  useEffect(() => {
    setValue(-1);
  }, [leftTrigger])

  useEffect(() => {
    setValue(1);
  }, [rightTrigger])

  const { rotate } = useSpring({ rotate: value, config: { mass: 1, tension: 25, friction: 4 } })

  return (
    <a.group 
      ref={group}
      rotation={rotate.interpolate(r => [0, 0, ((1 - r * 2) * Math.PI * 0.5 - Math.PI * 0.5) * 0.125 * flip])}
      >
      <mesh
        ref={mesh}
        scale={[2, 2, 2]}
        position={[0, -5, 0]}>
        <bufferGeometry attach="geometry" {...gltf.__$[1].geometry} />
        <meshPhysicalMaterial attach="material" {...gltf.__$[1].material} {...matSettings.drum} />
      </mesh>
    </a.group>
  )
}